var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplatesVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 13.6653,
    width: 5,
    height: 7,
    rx: 1.5,
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13.6653,
    width: 7,
    height: 7,
    rx: 1.5,
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.66528H5.5C4.67157 4.66528 4 5.33686 4 6.16528V8.16528C4 8.99371 4.67157 9.66528 5.5 9.66528H13.3133C13.7835 9.66528 14.2387 9.49961 14.5989 9.19737L20 4.66528Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplatesVector);
export default __webpack_public_path__ + "static/media/TemplatesVector.8b4de313492b9c7606adb5eaa8054241.svg";
export { ForwardRef as ReactComponent };